module.exports = __webpack_public_path__ + "img/development_team.3c20e990.png";